import classNames from "classnames";
import React from "react";
import {Element} from 'react-scroll';
import styles from "./SpyElements.module.scss"
import _ from "lodash";

export default ({children, offset = -235, duration = 500, hashSpy = true, names, ...rest}) => {
    const items = _.isArray(children) ? children : [children];
    return (<div className={classNames(styles["base"])}>
        {items && items.map((child, index) => {
            if (!child) {
                return null
            }
            return <React.Fragment key={index}>
                <Element name={hashSpy ? names[index] : index.toString()} {...rest}>
                    {child}
                </Element>
            </React.Fragment>
        })}
    </div>)
}